import { AcroNode } from "./types";
import { escapeHtml } from "./escapeHtml";

export function renderRadio(node: AcroNode, parentName?: string): string {
  const id = escapeHtml(String(node.id ?? ""));
  const fieldId = node.field_id ? escapeHtml(String(node.field_id)) : "";
  const title = node.title ? escapeHtml(String(node.title)) : "";
  const fieldIdAttr = fieldId ? ` data-field-id="${fieldId}"` : "";
  // Use parentName as the radio group name if provided, else fallback to node.id
  const radioName = parentName ? escapeHtml(parentName) : id;
  const input = `<input name="${radioName}" type="radio" data-id="${id}"${fieldIdAttr} class="form-radio" ${node.checked ? "checked" : ""} />`;
  const label = `<span class="text-sm">${title}</span>`;
  return `<label class="flex items-center gap-2">${input}${label}</label>`;
}